import { useParams } from 'react-router-dom';
import { useAccountParam } from 'hooks';

export type InvoiceParams = {
    accountId: string,
    vendorId: string,
    invoiceId: string,
};

export default function useInvoiceParams() : InvoiceParams {   
    const accountId = useAccountParam();
    const vendorId = useParams().vendorId ?? '';
    const { invoiceId } = useParams() as InvoiceParams;
    return { accountId, vendorId, invoiceId };
};